import React from "react";

export const LeaderboardHeader = () => {
  return (
    <h2 className="text-xl md:text-2xl font-bold text-gameGold mb-4 text-center">
      Global Leaderboard
    </h2>
  );
};